import React, { useState } from 'react'
import { Box, Typography, List, Button, makeStyles } from '@material-ui/core'
import { Check, Clear } from '@material-ui/icons'
import formatCurrency from 'utils/formatCurrency'
import { confirmTithe, cancelTithe } from 'actions/tithes'
import { useDispatch } from 'react-redux'
import ContributionListItem from 'components/MyGivingPage/ContributionListItem'
import formatDateString from 'utils/formatDateString'
import useTransactionListItemSelector from 'hooks/useTransactionListItemSelector'
import useCurrentUserEntities from 'hooks/useCurrentUserEntities'
import TitheDialog from 'components/MyGivingPage/Tithes/Pending/TitheDialog'
import useCurrentUserProp from 'hooks/useCurrentUserProp'
import { setBackdropLoading } from 'actions/status'

const useStyles = makeStyles(({ spacing }) => ({
  skipButton: {
    marginRight: spacing(1)
  }
}))

export default function Pending() {
  const [dialogState, setDialogState] = useState({ open: false })
  const transactionSelector = useTransactionListItemSelector('Tithe')
  const tithes = useCurrentUserEntities('tithes', 'unprocessedTithes')
  const isCurrentlyTithing = useCurrentUserProp('tithedJars').length > 0
  const classes = useStyles()
  const dispatch = useDispatch()

  function closeDialog() {
    setDialogState({ open: false })
  }

  function openDialog({ titheId, action, dispatchAction, formattedTransactionDate, formattedTransactionAmount, formattedAmount, percentage }) {
    function handleComplete() {
      dispatch(setBackdropLoading(true))
      dispatch(dispatchAction(titheId)).then(() => {
        closeDialog()
        dispatch(setBackdropLoading(false))
      })
    }

    setDialogState({
      open: true,
      title: `${action.charAt(0).toUpperCase() + action.slice(1)} Tithe?`,
      firstLine: `this will ${action} the following tithe:`,
      secondLine: `${percentage}% of ${formattedTransactionAmount} received on ${formattedTransactionDate}`,
      formattedAmount,
      handleComplete
    })
  }

  return (
    <React.Fragment>
      <List subheader={<Typography variant='subtitle2'>Pending</Typography>}>
        {tithes.map(({ amount, id, percentage }) => {
          const { encodedBankLogo, transactionName, accountName, transactionDate, transactionAmount } = transactionSelector(id)
          // TODO: Can do more DRYing here with other tithe list
          const formattedTransactionDate = formatDateString(transactionDate)
          const formattedTransactionAmount = formatCurrency(transactionAmount)
          const formattedAmount = formatCurrency(amount)
          const primaryText = `${formattedTransactionDate} ~ ${percentage}% of ${formattedTransactionAmount}`
          const dialogArgs = { titheId: id, formattedTransactionDate, formattedTransactionAmount, formattedAmount, percentage }

          return (
            <React.Fragment key={id}>
              <ContributionListItem
                { ...{
                  primaryText,
                  encodedBankLogo,
                  transactionName,
                  accountName,
                  contribution: formattedAmount
                } }
              />
              <Box display='flex' justifyContent='flex-end'>
                <Button
                  startIcon={<Clear />}
                  className={classes.skipButton}
                  variant='outlined'
                  color='secondary'
                  size='small'
                  onClick={() => openDialog({ ...dialogArgs, action: 'skip', dispatchAction: cancelTithe })}
                >
                  Skip
                </Button>
                <Button
                  disabled={!isCurrentlyTithing}
                  startIcon={<Check />}
                  variant='contained'
                  color='secondary'
                  size='small'
                  onClick={() => openDialog({ ...dialogArgs, action: 'confirm', dispatchAction: confirmTithe })}
                >
                  Confirm
                </Button>
              </Box>
            </React.Fragment>
          )
        })}
      </List>

      <TitheDialog
        { ...dialogState }
        handleClose={closeDialog}
      />
    </React.Fragment>
  )
}
